import { Injectable, inject } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, mergeMap } from 'rxjs/operators';

import { createEffectFactory } from '@core/ngrx-legacy';

import { ActivitySubscriptionsPerRoleHttpService } from './activity-subscriptions-per-role-http.service';
import { ActivitySubscriptionsPerRoleActions } from './activity-subscriptions-per-role.store';

@Injectable({ providedIn: 'root' })
export class ActivitySubscriptionsPerRoleEffects {
  private readonly ActivitySubscriptionsPerRoleService = inject(
    ActivitySubscriptionsPerRoleHttpService,
  );
  private readonly actions$ = inject(Actions);

  public effects = createEffectFactory(ActivitySubscriptionsPerRoleActions, this.actions$);

  public fetchActivitySubscriptionsPerRole$ = this.effects(
    ActivitySubscriptionsPerRoleActions.fetch,
    ({ payload }) =>
      this.ActivitySubscriptionsPerRoleService.loadActivitySubscriptionsPerRole(payload),
  );

  public updateActivitySubscriptionsPerRole$ = this.effects(
    ActivitySubscriptionsPerRoleActions.update,
    ({ payload }) =>
      this.ActivitySubscriptionsPerRoleService.updateActivitySubscriptionPerRole(payload),
  );

  public resetToDefaultActivitySubscriptionsPerRole$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ActivitySubscriptionsPerRoleActions.resetToDefaults),
      mergeMap(({ payload }) =>
        this.ActivitySubscriptionsPerRoleService.resetToDefaultActivitySubscriptionPerRole(
          payload,
        ).pipe(
          map(data =>
            ActivitySubscriptionsPerRoleActions.resetToDefaultsSuccess({ payload: data }),
          ),
        ),
      ),
    ),
  );
}
